import React, { useCallback, useState, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { showErrorToast } from "~/components/Toast";
import { fetchTypeConversation, addConversation } from "~/store/actions/actions.conversations.jsx";
import { NotFoundError } from "~/utils/errors/index.js";

export const ConversationResolver = ({ children, type, id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [, setLoading] = useState(false);
  const callbackRef = useRef(children?.props?.onClick);

  const payload = useMemo(() => {
    return {
      type: type === "user" ? "custom" : type,
      value: type === "user" ? [id] : id,
    };
  }, [type, id]);

  const handleClick = useCallback(async () => {
    let action;

    const getResponseOrThrowError = (response) => {
      const { error } = response;

      if (error) {
        if (error instanceof Error) {
          throw error;
        }
        throw new Error("Unknown Error!");
      }

      return response;
    };

    const getConversation = async () => {
      const response = await dispatch(fetchTypeConversation(id, type));
      return (action = getResponseOrThrowError(response));
    };

    const createConversation = async () => {
      await getConversation().catch(async (error) => {
        if (error instanceof NotFoundError) {
          const response = await dispatch(addConversation(payload));
          return (action = getResponseOrThrowError(response));
        }

        throw error;
      });
    };

    setLoading(true);

    await createConversation()
      .catch(() => showErrorToast(t("Failed to open conversation")))
      .finally(() => {
        setLoading(false);
        if (action) {
          const { response = {} } = action;
          const { result = {} } = response;
          const { single: conversationId } = result;

          if (conversationId) {
            typeof callbackRef.current === "function" && callbackRef.current(conversationId);
          }
        }
      });
  }, [id, type, dispatch, payload, t]);

  return React.cloneElement(children, { onClick: handleClick });
};
